import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a0f21532"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "top-contact-content-mail-box"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-contact-content-mail-box-title" }, [
  /*#__PURE__*/_createTextVNode(" 新着車両や在庫情報などを"),
  /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
  /*#__PURE__*/_createTextVNode("お知らせします ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-contact-content-mail-box-text sans" }, [
  /*#__PURE__*/_createTextVNode(" 新しく入荷したクルマや、"),
  /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
  /*#__PURE__*/_createTextVNode("おすすめのクルマ情報など、"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("お客様のお役にたつ情報をお届けします。"),
  /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
  /*#__PURE__*/_createTextVNode("是非ご登録ください。 ")
], -1))
const _hoisted_4 = { class: "top-contact-content-mail-box-search of" }
const _hoisted_5 = { class: "mail-box-error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_center = _resolveComponent("center")!
  const _component_vue_element_loading = _resolveComponent("vue-element-loading")!

  return (!_ctx.hideMagazineForm)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_center, null, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "メールアドレス",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mailForm.mailAddress) = $event))
          }, null, 512), [
            [_vModelText, _ctx.mailForm.mailAddress]
          ]),
          (!_ctx.mailForm.sending)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submitMail()))
              }, _toDisplayString(_ctx.mailForm.suceeded ? '登録完了' : '送信する'), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_vue_element_loading, {
            active: _ctx.mailForm.sending,
            spinner: "spinner",
            color: "#004da0"
          }, null, 8, ["active"]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.mailForm.error), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}